import { FciValueTypes } from '../constants'

export const tableHeaders = [
  'Charged Date',
  'Reference',
  // 'Owed to account',
  'Description',
  'Type',
  'Int. Rate',
  'Int. From',
  'Deferred',
  'Orignial Balance',
  'Unpaid Balance',
  'Accrued Interest',
  'Total Due',
]

export const tableBodyData: Record<string, FciValueTypes> = {
  date: FciValueTypes.Date,
  reference: FciValueTypes.Text,
  // owedToAccount: FciValueTypes.Text,
  description: FciValueTypes.Text,
  type: FciValueTypes.Text,
  interestRate: FciValueTypes.Percent,
  interestFrom: FciValueTypes.Date,
  deferred: FciValueTypes.Boolean,
  origianlBalance: FciValueTypes.Number,
  unpaidBalance: FciValueTypes.Number,
  accruedInterest: FciValueTypes.Number,
  totalDue: FciValueTypes.Number,
}
